export default {
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    dataPart: {
      type: [String],
      default: ''
    }
  },
  data() {
    return {
      id: `v-img-item-id-${parseInt(Math.random() * 1e5)}`,
      detail: {
        ...this.item
      },
      showDetailDialog: false
    };
  },
  mounted() {},
  watch: {
    item() {
      this.detail = this.item;
    }
  },
  computed: {
    targetUrl() {
      if (this.dataPart) {
        return `/video/detail/${this.item.itemId}?fpos=${this.dataPart}`;
      }
      return `/video/detail/${this.item.itemId}?fpos=${this.$route.name}`;
    }
  },
  methods: {
    moveLeave() {
      var _this$$refs, _this$$refs$coverVide;
      this.showDetailDialog = false;
      (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$coverVide = _this$$refs.coverVideo) === null || _this$$refs$coverVide === void 0 ? void 0 : _this$$refs$coverVide.pause();
    },
    moveEnterItem() {
      var _this$detail;
      this.showDetailDialog = true;
      if ((_this$detail = this.detail) !== null && _this$detail !== void 0 && _this$detail.smallVideo) {
        this.$nextTick(() => {
          var _this$$refs2, _this$$refs2$coverVid;
          (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : (_this$$refs2$coverVid = _this$$refs2.coverVideo) === null || _this$$refs2$coverVid === void 0 ? void 0 : _this$$refs2$coverVid.play();
        });
        return;
      }
      this.$service.ApiItemsDetail({
        id: this.item.id,
        isResize: 1,
        style: encodeURI('image/resize,m_mfit,w_480,h_270')
      }).then(res => {
        this.detail = {
          ...this.detail,
          ...res.data
        };
      }).catch(err => {
        console.log(err);
      });
      this.$service.ApiIndexGetSmallVideo({
        itemId: this.item.id
      }).then(res => {
        this.detail.smallVideo = res.data;
        this.$nextTick(() => {
          var _this$$refs3, _this$$refs3$coverVid;
          (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : (_this$$refs3$coverVid = _this$$refs3.coverVideo) === null || _this$$refs3$coverVid === void 0 ? void 0 : _this$$refs3$coverVid.play();
        });
      }).catch(err => {
        console.log(err);
      });
    }
  }
};